import { Bug } from 'lucide-react'
import { sendFeedbackToDeveloper } from '@/lib/feedback'
import { useTelegram } from '@/hooks/useTelegram'
import { ICON_DANGER_CLASS } from '@/components/ui/Tone'

interface FeedbackButtonProps {
  className?: string
}

export function FeedbackButton({ className = '' }: FeedbackButtonProps) {
  const { hapticFeedback } = useTelegram()

  const handleFeedbackClick = () => {
    try {
      hapticFeedback.impact('light')
      sendFeedbackToDeveloper()
    } catch (error) {
      console.error('Failed to send feedback:', error)
    }
  }

  return (
    <button
      onClick={handleFeedbackClick}
      className={`
        flex items-center justify-center p-2 rounded-lg 
        bg-red-500/10 hover:bg-red-500/20 active:bg-red-500/30
        transition-colors duration-150
        ${className}
      `}
      title="Сообщить о проблеме"
    >
      <Bug className={`w-5 h-5 ${ICON_DANGER_CLASS}`} />
    </button>
  )
}